import { jsx } from 'react/jsx-runtime';
import { Paragraph } from '../pararaph/pararaph.esm.js';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use standard HTML elements with Bootstrap's `small` class instead.
 * See the type documentation above for migration examples.
 */ const Description = ({ children, className })=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️  Description component is deprecated and will be removed in a future version.\n' + 'Please migrate to using standard HTML elements with Bootstrap classes:\n' + '• Replace <Description> with <p className="small">\n');
    }
    return jsx(Paragraph, {
        small: true,
        children: children,
        className: className
    });
};

export { Description };
